/** The categories the panel's home grid offers (item 0389).
 *
 *  "Favorites" is not a per-visitor list: it is the venue-level `favorite`
 *  flag an admin ticks on a POI ("Favorito" in the POI form), and the
 *  category with slug `favorites` is a virtual one -- the public /pois
 *  endpoint answers it with every active POI that has the flag, whatever
 *  its own category. With no flagged POI the tile opened an empty list, so
 *  it is left out of the grid until one exists.
 *
 *  `pois` is the list the viewer booted with, i.e. the PUBLISHED version
 *  (item 0375) -- or, under ?preview=, the version being previewed -- and
 *  already active-only. A draft edit therefore changes nothing until it is
 *  published, and a publish reaches the screens through PublishWatcher's
 *  reload. The grid is a CSS grid fed from this array, so leaving the tile
 *  out leaves no hole in either layout.
 *
 *  Only the panel's grid uses this: the bundle's category list is untouched,
 *  so a POI an admin filed under "Favorites" keeps its marker icon. */
export const FAVORITES_SLUG = "favorites";

export function homeCategories(categories, pois) {
  if (!categories) return [];
  const anyFavorite = (pois ?? []).some((p) => p.favorite);
  return anyFavorite ? categories : categories.filter((c) => c.slug !== FAVORITES_SLUG);
}
